import React, { useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import { HHIEButton } from './utility/HHIEButton';
import Loading from './utility/Loading';
import '../styles/Logout.css';
import { HHIEError } from './utility/HHIEError';

export default function Logout() {
    const [logoutUrl, setLogoutUrl] = useState(null);
    const [error, showError] = useState(false);

    useEffect(() => {
        const logOutFunc = async () => {
            sessionStorage.clear();
            if (sessionStorage.getItem("user") != null) {
                throw new Error("Session storage was not cleared");
            }
            let link = "";
            link = await getLink();
            if (link === null || link === "") {
                showError(true);
                return;
            }
            
            const isValidLink = await linkIsValid();
            
            if (isValidLink) {
                setLogoutUrl(link);
                setTimeout(() => window.location.href="/", 4000);
            }
            else {
                showError(true);
            }
        };
        logOutFunc();
    }, []);

    const getLink = async () => {
        return fetch('api/login/GetLogoutLink')
        .then(async (response) => {
            try {
                return await response.json()
                    .then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message;
                    });
            }
            catch (ex) {
                return console.log(ex);
            }
        })
        .catch((ex) => {
            console.log(ex);
        });
    };
    const linkIsValid = async () => {
        let result = false;
        result =  await fetch('api/login/IsLogoutLinkValid')
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message;
                    });
                }
                catch (ex) {
                    return console.log(ex);
                }
            })
            .catch((ex) => {
                console.log(ex);
            });
        return result;
    };

    return (
        <>
        {!error && 
        <div className="logout-contents">
            <Loading message={<div>Logging you out. . . please wait for the browser to redirect you, or press</div>}/>
            <HHIEButton
                id="return-home-btn"
                margint={15}
                onClick={() => window.location.href="/" }
                title="Return to Homepage"
            />
            <Row>
                <iframe id="logout-of-salesforce"
                    title="logout of salesforce"
                    width="1"
                    height="1"
                    src={logoutUrl}
                >
                </iframe>
            </Row>
        </div>
        }
        {error && 
            <HHIEError
                message="This logout link is invalid, please inform the HHIE. Email helpdesk@hawaiihie.org or phone (808) 441-1374."
                onClick={
                    () => {
                        alert("Email helpdesk@hawaiihie.org or phone (808) 441-1374. ");
                        window.location.href="/";
                    }
                }/>
        }
        </>
    );
}